import React, { useState } from 'react';
import './Header.css';
import logo from '../utility/mainLogo.png';
import paymentQrImage from '../utility/Trekverse_Payments.jpeg';

// 1. Add the new props to the component signature
const Header = ({ onNavigate, isLoggedIn, userName, onLogout }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleNavClick = (section) => {
    onNavigate(section);
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo Section */}
        <div className="logo-section" onClick={() => handleNavClick('home')} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="TrekVerse Logo" className="logo" />
          <span className="trekverse-title">TrekVerse</span>
        </div>

        {/* Navigation */}
        <nav className={`nav ${mobileMenuOpen ? 'active' : ''}`}>
          <button onClick={() => handleNavClick('programs')} className="nav-link">
            Programs
          </button>
          <button onClick={() => handleNavClick('advance')} className="nav-link">
            Advance Programs
          </button>
          <button onClick={() => handleNavClick('about')} className="nav-link">
            About
          </button>

          <div className="auth-buttons">
            {isLoggedIn ? (
              <>
                <button
                  onClick={() => handleNavClick('dashboard')}
                  className="nav-link"
                  style={{ marginRight: '15px' }}
                >
                  My Dashboard
                </button>
                <span style={{ color: 'white', fontWeight: 'bold', marginRight: '15px', alignSelf: 'center' }}>
                  Welcome, {userName}
                </span>
                <button onClick={onLogout} className="btn login-btn">
                  Log Out
                </button>
              </>
            ) : (
              <>
                <button onClick={() => handleNavClick('login')} className="btn login-btn">
                  Log In
                </button>
                <button onClick={() => handleNavClick('register')} className="btn login-btn">
                  Sign Up
                </button>
                <button onClick={() => window.open('https://tinyurl.com/TREKVERSE-REGISTRATION', '_blank')} className="btn register-btn">
                  Registration
                </button>
              </>
            )}
          </div>
        </nav>

        {/* Hamburger Menu */}
        <div className="hamburger" onClick={toggleMobileMenu}>
          <span className={mobileMenuOpen ? 'active' : ''}></span>
          <span className={mobileMenuOpen ? 'active' : ''}></span>
          <span className={mobileMenuOpen ? 'active' : ''}></span>
        </div>
      </div>
    </header>
  );
};

export default Header;